import { useTranslation } from 'react-i18next';
import { useActiveMembership } from '@/features/session/useActiveMembership';
import { StripeIntegration } from './StripeIntegration';
import { QuoteWidgetCard } from './QuoteWidgetCard';
import { MessagingPhoneCard } from './MessagingPhoneCard';
import { IntegrationCard } from './IntegrationCard';
import { DirectoryListingCard } from './DirectoryListingCard';
import { useIntegrations } from './api';

// §33 kill switch, mirroring the server's MESSAGING_ENABLED. Off until
// WrapForce's A2P 10DLC campaign is approved: the onboarding card is replaced
// by the plain twilio provider card, which the grid already renders as
// "coming soon" like every other unbuilt integration.
const MESSAGING_ENABLED = import.meta.env.VITE_MESSAGING_ENABLED === 'true';

export function IntegrationsPage() {
  const { t } = useTranslation('integrations');
  const { membership } = useActiveMembership();
  const workspaceId = membership?.workspaceId ?? null;
  const { data } = useIntegrations(workspaceId);

  return (
    <div className="flex flex-col gap-6 p-6">
      <div>
        <h1 className="font-display text-xl font-bold text-ink">{t('pageTitle')}</h1>
        <p className="mt-1 text-sm text-muted">{t('pageSubtitle')}</p>
      </div>
      <div className="grid grid-cols-1 gap-4 lg:grid-cols-2" data-tour="page-integrations-grid">
        <StripeIntegration workspaceId={workspaceId} />
        <QuoteWidgetCard workspaceId={workspaceId} />
        <DirectoryListingCard workspaceId={workspaceId} />
        {MESSAGING_ENABLED ? <MessagingPhoneCard workspaceId={workspaceId} /> : null}
        {/* twilio is superseded by the Text Messaging & Phone card above */}
        {data?.items
          .filter((integration) => !(MESSAGING_ENABLED && integration.provider === 'twilio'))
          .map((integration) => (
            <IntegrationCard key={integration.provider} integration={integration} workspaceId={workspaceId} comingSoon />
          ))}
      </div>
    </div>
  );
}
